import { render, staticRenderFns } from "./translationIcon.vue?vue&type=template&id=a1617ce4&scoped=true"
import script from "./translationIcon.vue?vue&type=script&lang=js"
export * from "./translationIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1617ce4",
  null
  
)

export default component.exports